export default __webpack_public_path__ + "static/media/01 Track 1.d3a8edb6.mp3";